import { Skeleton } from 'antd5';
import { useTranslation } from 'react-i18next';

import { SkeletonGrid, SkeletonTile } from './DashboardSkeleton.style';
import { DASHBOARD_GRID_MARGIN, DASHBOARD_ROW_HEIGHT } from './widgetSizePresets';

const [, MARGIN_Y] = DASHBOARD_GRID_MARGIN;

const tileHeight = (h: number) => h * DASHBOARD_ROW_HEIGHT + (h - 1) * MARGIN_Y;

// Default to size of default widgets
const TILE_SPANS = [
  { span: 4, height: 3 },
  { span: 4, height: 3 },
  { span: 4, height: 3 },
  { span: 12, height: 6 },
];

export function DashboardSkeleton() {
  const { t } = useTranslation();

  return (
    <SkeletonGrid
      role="status"
      aria-label={t('components.dashboardLoading', 'Loading dashboard…')}
      data-testid="dashboard-loading"
    >
      {TILE_SPANS.map(({ span, height }, index) => (
        <SkeletonTile key={index} $span={span} $height={tileHeight(height)}>
          <Skeleton
            active
            title={{ width: '40%' }}
            paragraph={{ rows: 2, width: ['70%', '55%'] }}
          />
        </SkeletonTile>
      ))}
    </SkeletonGrid>
  );
}
